export enum EnumExportOrderToPOSSyncStatuses {
    failure = "failure",
    pending = "pending",
    started = "started",
    sent = "sent",
    success = "success",
}

export type TExportOrderToPOSStatusResponse = {
    created_on: number;
    destination: {
        account_id: string;
        location_id: string;
        order_id: string;
        platform: string;
    };
    exported_on: number;
    status: EnumExportOrderToPOSSyncStatuses;
};
